import { gql } from '@apollo/client'

export default gql`
  mutation UpdateVoohCampaignNote($input: UpdateVoohCampaignNoteInput!) {
    updateVoohCampaignNote(input: $input) {
      success
    }
  }
`
